module.exports = __webpack_public_path__ + "img/btnStatus1.d96d12ba.png";